import { render } from "./Sensors.vue?vue&type=template&id=45830530"
import script from "./Sensors.vue?vue&type=script&lang=js"
export * from "./Sensors.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__